import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import { useToast } from "../../contexts/ToastContext";
import { getUserInfo } from "../../services/authService";
import Loader from "../../components/elements/Loader";

const SocialLoginRedirect = () => {
  const { showSuccessToast } = useToast();
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const { setToken, setUser, redirectPath, setRedirectUrl } = useAuth();

  useEffect(() => {
    const handleSocialLogin = async () => {
      const token = params.get("token");
      if (token) {
        setToken(token);
        const res = await getUserInfo();
        setUser(res.data.data);
        showSuccessToast(res.data.message);
        console.log("Redirect Path:", redirectPath);
        navigate(redirectPath);
        setRedirectUrl("/");
      } else {
        navigate("/login");
      }
    };

    handleSocialLogin();
  }, []);

  return <Loader />;
};

export default SocialLoginRedirect;
